import React from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  yellow: { bg: '#FEFCE8', border: '#E9D96E', tape: '#F0E87A', text: '#5C4A00' },
  blue:   { bg: '#EBF4FF', border: '#BFDBFE', tape: '#93C5FD', text: '#1E3A5F' },
  green:  { bg: '#F0FDF4', border: '#BBF7D0', tape: '#86EFAC', text: '#14532D' },
  pink:   { bg: '#FFF1F2', border: '#FECDD3', tape: '#FDA4AF', text: '#881337' },
};

const StickyNote = ({ children, color = 'yellow', rotate = '-2deg', delay = 0, className = '' }) => {
  const c = COLORS[color];
  return (
    <motion.div
      initial={{ opacity: 0, y: 16, rotate: 0 }}
      whileInView={{ opacity: 1, y: 0, rotate: parseFloat(rotate) }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay, type: 'spring', stiffness: 120 }}
      className={`relative p-4 rounded-sm shadow-md ${className}`}
      style={{ background: c.bg, border: `1px solid ${c.border}`, transform: `rotate(${rotate})` }}
    >
      {/* Paper tape at top */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-12 h-5 rounded-sm opacity-70"
        style={{ background: c.tape, border: `1px solid ${c.border}` }} />
      <div className="font-handwritten text-sm leading-relaxed" style={{ color: c.text }}>
        {children}
      </div>
    </motion.div>
  );
};

export default StickyNote;